import React from 'react'
import { Link } from 'react-router-dom'
import VkIcon from '../images/vk.svg'
import YoutubeIcon from '../images/youtube.svg'
import { getFooterBlocks, IFooterBlock } from '~helpers/constant'
import TelegramIcon from '../images/telegram.svg'
import WhatsAppIcon from '../images/whatsapp.svg'
import {useAppSelector} from "~/hooks/redux";

export const Footer: React.FC = () => {
  const { country } = useAppSelector(state => state.countryReducer);
  const blocks = getFooterBlocks(country?.value);

  const renderLink = (link: { url?: string; view: string; fontWeight: number; name: string; section?: string }) => (
    <div className='onlinepbx__footer__content'>
      <div key={!!link.url ? link.url : link.view}>
        {(!!link.url && (
          <a
            className='onlinepbx__footer__link'
            style={{ fontWeight: link.fontWeight }}
            rel='noreferrer'
            target='_blank'
            href={link.url}
          >
            {link.name}
          </a>
        )) || (
          <Link className='onlinepbx__footer__link' to={`/${link.view}`}>
            {link.name}
          </Link>
        )}
      </div>
      <div className='onlinepbx__footer__section'>{link.section}</div>
    </div>
  )

  return (
    <div className='onlinepbx__footer__wrapper'>
      <div className='onlinepbx__container'>
        <div className='onlinepbx__footer__logo'>
          <div className='onlinepbx__footer__logo__line' />
          <div className='onlinepbx__footer__logo__line' />
        </div>
        <div className='onlinepbx__footer'>
          <div className='onlinepbx__footer__links'>
            {blocks.map((block: IFooterBlock) => (
              <div className='onlinepbx__footer__block' key={block.header}>
                <div className='onlinepbx__footer__header'>{block.header}</div>
                {(block.subHeaders || []).map(subHeaderBlock => ([
                  <div className='onlinepbx__footer__subheader' key={'subheader-' + subHeaderBlock.header}>{subHeaderBlock.header}</div>,
                  (subHeaderBlock.links || []).map(renderLink)
                ]))}
                {(block.links || []).map(renderLink)}
              </div>
            ))}
          </div>
          <div className='onlinepbx__footer__socials'>
            <a className='onlinepbx__footer__social' rel='noreferrer' target='_blank' href='http://vk.com/onlinepbx'>
              <VkIcon className='onlinepbx__footer__social__icon' />
            </a>
            <a
              className='onlinepbx__footer__social'
              rel='noreferrer'
              target='_blank'
              href='https://www.youtube.com/channel/UCw7X4f9enjNnZnurK8KXLfw'
            >
              <YoutubeIcon className='onlinepbx__footer__social__icon' />
            </a>
            <a
              className='onlinepbx__footer__social'
              rel='noreferrer'
              target='_blank'
              href='https://tlgg.ru/techpbx_bot'
            >
              <TelegramIcon className='onlinepbx__footer__social__icon' />
            </a>
            {false && (
              <a
                className='onlinepbx__footer__social'
                rel='noreferrer'
                target='_blank'
                href='https://wa.me/79505546601'
              >
                <WhatsAppIcon className='onlinepbx__footer__social__icon' />
              </a>
            )}
          </div>
          {country?.value === 'UZ' &&
          <a
            className='onlinepbx__footer__policy__link'
            rel='noreferrer'
            target='_blank'
            href={'https://pbx.uz/privacy/contract.pdf'}
          >
            Лицензионный договор между ООО «Chukreev PBX» и  ООО «Тесла Телеком»
          </a>}
          <div className='onlinepbx__footer__policy'>
            <a
              className='onlinepbx__footer__policy__link'
              rel='noreferrer'
              target='_blank'
              href={process.env.PUBLIC_DIR + '/privacy/conf.pdf'}
            >
              Политика обработки персональных данных
            </a>
            <a
              className='onlinepbx__footer__policy__link'
              rel='noreferrer'
              target='_blank'
              href={process.env.PUBLIC_DIR + '/privacy/oferta3-0.pdf'}
            >
              {country?.value === 'UZ' ? 'Договор оферы' : 'Оферта'}
            </a>
            <a
              className='onlinepbx__footer__policy__link'
              rel='noreferrer'
              target='_blank'
              href='https://partners.onlinepbx.ru/files/oferta.pdf'
            >
              Соглашение об участии в партнерских программах
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
